import React, { useEffect, useState } from 'react';

import { Redirect, useLocation } from 'react-router-dom'

import { useAppState } from "./../../state";

import FeatureFlagList from "./FeatureFlagList";

// react-bootstrap components
import {
    Badge,
    Button,
    Card,
    Collapse,
    Form,
    InputGroup,
    Navbar,
    Nav,
    OverlayTrigger,
    Table,
    Tooltip,
    Container,
    Row,
    Col,
    Modal,
    Tab,
    Spinner
} from "react-bootstrap";

import "./FeatureFlagPage.scss";

function FeatureFlagPage(props) {
    const [isSaveLoading, setIsSaveLoading] = useState(false);
    const [saveSucceed, setSaveSucceed] = useState(false);

    const [errorMessage, setErrorMessage] = useState();
    const [cardCSSClass, setCardCSSClasses] = useState("");

    const [redirect, setRedirect] = useState(false);

    const location = useLocation();
    
    let pageTitleContent;

    const onSaveClick = async () => {
        try {
            setSaveSucceed(false);
            setIsSaveLoading(true);

            setIsSaveLoading(false);
            setSaveSucceed(true);
            return true;
        }
        catch (e) {
            errorMessage = "error";
            console.log(e);
        }
        setIsSaveLoading(false);
    }

    let errorMessageContent;
    if (errorMessage && errorMessage.length > 0) {
        errorMessageContent = (
            <Row>
                <Col className="d-flex justify-content-center">
                    <label className="error">{errorMessage}</label>
                </Col>
            </Row>
        );
    }

    let succeedMessageContent;
    if (saveSucceed) {
        succeedMessageContent = (
            <Row>
                <Col className="d-flex justify-content-center">
                    <label className="success">Feature flags saved successfully</label>
                </Col>
            </Row>
        );
    }

    if (redirect && location.pathname.indexOf("featureFlags") >= 0) {
        return <Redirect to="/dashboard" />
    }

    let saveButtonContent = (
        <>
            <i className="fa fa-save"></i>
            Save
        </>
    )

    if (isSaveLoading) {
        saveButtonContent = (
            <>
                <Spinner animation="border" size="sm" />
                <span> Saving... </span>
            </>
        );
    }

    pageTitleContent = (
        <Card.Header>
            <p>Enable one or more feature flag(s) by turning on and off the switch near each flag.</p>
            <p>Note: Changing the feature flags will require you to log out from the application, close the browser window and all tabs, then open a new browser window for the new setting to get in effect</p>
        </Card.Header>
    )
    return (
        <>
            <Container fluid id="featureFlagPage">
                <Card className={`bg-white border-0`}>
                    <Card.Body>
                        <Container>
                            <Card className={`table-with-switches bg-white border-0 ${cardCSSClass}`}>
                                {pageTitleContent}
                                <Card.Body>
                                    <FeatureFlagList />
                                </Card.Body>
                                <Card.Footer>
                                    <Row>
                                        <Col className="d-flex justify-content-center ">
                                            <Button className="mr-1" variant="primary" onClick={!isSaveLoading ? onSaveClick : null}>
                                                {saveButtonContent}
                                            </Button>
                                        </Col>
                                    </Row>
                                    {errorMessageContent}
                                    {succeedMessageContent}
                                </Card.Footer>
                            </Card>
                        </Container>
                    </Card.Body>
                </Card>
            </Container>
        </>
    )
}

export default FeatureFlagPage;